import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateNotificationSettingParams {
  userId: string; // site user id
  enabled: boolean;
}

export class UpdateNotificationSettingRequest extends Request<IUpdateNotificationSettingParams, IResult> {
  constructor(params: IUpdateNotificationSettingParams) {
    super('updateNotificationSetting', params);
  }
}
